// extracted by mini-css-extract-plugin
export var button = "_ev-0";
export var donut = "_ev-1";
export var donutFill = "_ev-3";
export var donutTrack = "_ev-2";